import React from 'react';
import PropTypes from 'prop-types';
import NukaCarousel from 'nuka-carousel';

const propTypes = {
  slideIndex: PropTypes.number.isRequired,
  afterSlide: PropTypes.func.isRequired,
  slidesToShow: PropTypes.number,
  cellSpacing: PropTypes.number,
  wrapAround: PropTypes.bool,
  autoplayInterval: PropTypes.number,
  children: PropTypes.node,
};

const Carousel = ({
  slideIndex,
  afterSlide,
  slidesToShow,
  cellSpacing,
  wrapAround,
  autoplayInterval,
  children,
}) => {
  return (
    <NukaCarousel
      speed={300}
      autoplay={autoplayInterval > 0}
      slideIndex={slideIndex}
      afterSlide={afterSlide}
      slidesToShow={slidesToShow}
      cellSpacing={cellSpacing}
      wrapAround={wrapAround}
      autoplayInterval={autoplayInterval}
      heightMode="max"
      withoutControls
    >
      {children}
    </NukaCarousel>
  );
};

Carousel.propTypes = propTypes;

export default Carousel;
